import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import clsx from "clsx";
import { makeStyles, Grid, Typography, createStyles } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { useAppLoad } from "../../appLoadContext";
addRegisteredSectionLayout({
    name: "DocumentStatusSection",
    displayName: "DocumentStatusSection",
    settings: {
        forceRenderAsHeaderWithoutGroup: true
    }
});
const DocumentStatusSection = (props) => {
    const { className, onClick } = props;
    const classes = useStyles(props);
    const { documentStatusDescription } = useAppLoad();
    return (_jsx(_Fragment, { children: _jsxs(Grid, { container: true, className: clsx(className, classes.root), onClick: onClick, children: [_jsx(Grid, { item: true, xs: true, className: clsx(classes.container, classes.headerContainer), children: _jsx(Typography, { variant: "body1", className: classes.header, children: _jsx(FormattedMessage, { id: "form.document-status-section.header", description: "Header for document status section on post process", defaultMessage: "Document status" }) }) }), _jsx(Grid, { item: true, xs: true, className: clsx(classes.container, classes.itemContainer), children: _jsx(Typography, { variant: "body2", children: documentStatusDescription }) })] }) }));
};
const useStyles = makeStyles((theme) => createStyles({
    root: {
        height: theme.spacing(8)
    },
    header: {
        textTransform: "uppercase"
    },
    headerContainer: {
        justifyContent: "flex-start"
    },
    itemContainer: {
        justifyContent: "flex-end"
    },
    container: {
        display: "flex",
        alignItems: "center"
    }
}), { name: "DployDocumentStatusSection" });
DocumentStatusSection.displayName = "DployDocumentStatusSection";
export { DocumentStatusSection };
//# sourceMappingURL=DocumentStatusSection.js.map